import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ファイル存在確認 API 操作クラス
 */
export default class ExistS3Files {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### POST ExistS3Files
   *
   * - 取得メソッドだが、URLパラメータで渡しきれない文字数になるのでPOSTで情報を取得する
   */
  public async post(userStore: LoginUser, requestBody: ExistS3FilesPostModel): Promise<boolean> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.ExistS3Files, formatParams);
    const response = await this.commonService.executePost<boolean>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface ExistS3FilesPostModel {
  /** 存在確認対象のURL */
  urls: string[];
}
